"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabPanel = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var clsx_1 = __importDefault(require("clsx"));
var O = __importStar(require("fp-ts/Option"));
var Option_1 = require("fp-ts/Option");
var function_1 = require("fp-ts/function");
var React = __importStar(require("react"));
var Icon_1 = require("../Icon/Icon");
var index_1 = require("../index");
var MessageFooter_1 = require("./MessageFooter");
require("./tabPanel.css");
var TabPanel = /** @class */ (function (_super) {
    __extends(TabPanel, _super);
    function TabPanel(props) {
        var _this = _super.call(this, props) || this;
        _this.handleTabClick = function (slug) { return function () {
            if (_this.props.foldable) {
                _this.setState(function (prevState) { return ({
                    activeSlug: prevState.activeSlug === slug ? 'noTabSelected' : slug,
                }); });
            }
            if (_this.props.onClick) {
                _this.props.onClick(slug);
            }
        }; };
        _this.themeHoverRefiner = function () {
            return (_this.props.theme.type === 'hoverable' || _this.props.theme.type === 'highlighted') && _this.state.hover;
        };
        _this.buildOpenCloseClassName = function (item) {
            if (_this.props.foldable) {
                return (0, function_1.pipe)(O.some(item), O.filter(function () { return item.slug === _this.state.activeSlug; }), O.map(function () { return 'tab-panel-item-open'; }), O.getOrElse(function () { return (_this.state.activeSlug === 'noTabSelected' ? 'tab-panel-item-close' : ''); }));
            }
            return '';
        };
        _this.tabPanelItemClassNamesBuilder = function (item) {
            return (0, clsx_1.default)('tab-panel-item', item.color ? "tab-panel-item-".concat(item.color) : null, _this.props.theme.type === 'alt' ? 'tab-panel-item-alt' : null, _this.buildOpenCloseClassName(item), _this.props.foldable ? 'tab-panel-item-foldable' : null, _this.props.theme.type !== 'default' && _this.state.hover && _this.state.activeSlug === 'noTabSelected'
                ? 'tab-panel-item-hover'
                : null);
        };
        _this.renderTab = function (item) { return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: _this.tabPanelItemClassNamesBuilder(item), onClick: _this.handleTabClick(item.slug) }, { children: [(0, function_1.pipe)(O.fromNullable(item.icon), (0, Option_1.map)(function (icon) { return (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: icon }); }), O.toNullable), (0, jsx_runtime_1.jsx)("span", { children: item.text })] }), item.slug)); };
        _this.renderActions = function (action) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "tab-panel-action" }, { children: (0, jsx_runtime_1.jsx)(index_1.Button, __assign({ className: "tab-panel-action", icon: action.icon, styleType: "minimal", onClick: action.onClick, link: action.link, size: "sm" }, { children: (0, jsx_runtime_1.jsx)("span", { children: action.content }) }), action.slug) }), action.slug)); };
        _this.borderRefiner = function () { return _this.props.theme.type === 'hoverable' && _this.props.theme.border === true; };
        _this.tabPanelClassNamesBuilder = function () {
            return (0, clsx_1.default)('tab-panel', "tab-panel-theme-".concat(_this.props.theme.type), _this.borderRefiner() ? 'tab-panel-border' : null);
        };
        _this.itemsClassNamesBuilder = function () {
            return (0, clsx_1.default)('tab-panel-items', _this.themeHoverRefiner() ? 'tab-panel-items-hover' : null);
        };
        _this.wrapperClassNamesBuilder = function () {
            return (0, clsx_1.default)('tab-panel-wrapper', _this.props.foldable && _this.state.activeSlug === 'noTabSelected'
                ? 'tab-panel-wrapper-close'
                : 'tab-panel-wrapper-open', _this.props.footerLine ? 'footer-line' : null, _this.borderRefiner() ? 'tab-panel-wrapper-border' : null, _this.themeHoverRefiner() ? 'tab-panel-wrapper-hover' : null);
        };
        _this.renderHighLight = function () {
            return _this.props.theme.type === 'highlighted' ? ((0, jsx_runtime_1.jsx)("div", __assign({ className: "tab-panel-highlight" }, { children: _this.props.theme.highlight }))) : null;
        };
        _this.handleRenderProp = function (slug) {
            return (0, function_1.pipe)(O.some(_this.props), O.chainNullableK(function (p) { return (p.foldable === true ? p.render : null); }), O.chain(function (render) { return (slug !== 'noTabSelected' ? O.some(render(slug)) : O.none); }), O.toNullable);
        };
        var activeSlug = _this.props.items.filter(function (i) { return i.active; })[0];
        _this.state = {
            activeSlug: activeSlug ? activeSlug.slug : 'noTabSelected',
            hover: false,
        };
        return _this;
    }
    TabPanel.prototype.render = function () {
        var _this = this;
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ id: this.props.id, className: (0, clsx_1.default)(this.tabPanelClassNamesBuilder()), css: (0, react_1.css)(this.props.theme.panelCustomStyle), onMouseEnter: function () { return _this.setState({ hover: true }); }, onMouseLeave: function () { return _this.setState({ hover: false }); }, 
            // eslint-disable-next-line react/no-unknown-property
            onLoad: this.props.onLoad }, { children: [this.renderHighLight(), (0, jsx_runtime_1.jsxs)("div", __assign({ className: this.itemsClassNamesBuilder() }, { children: [this.props.items.map(this.renderTab), this.props.actions && this.props.actions.map(this.renderActions)] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, clsx_1.default)(this.wrapperClassNamesBuilder()), css: (0, react_1.css)(this.props.theme.contentWrapperCustomStyle) }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, clsx_1.default)('tab-panel-content', this.props.theme.type) }, { children: [this.props.children, this.handleRenderProp(this.state.activeSlug)] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "tab-panel-footer" }, { children: this.props.footer }))] }))] })));
    };
    TabPanel.Footer = MessageFooter_1.Footer;
    return TabPanel;
}(React.PureComponent));
exports.TabPanel = TabPanel;
TabPanel.defaultProps = {
    foldable: false,
};
//# sourceMappingURL=TabPanel.js.map